import { css } from 'linaria';

export const selectTintColorContainer = css`
  display: inline-flex;
  flex-direction: column-reverse;
  gap: var(--space-150);

  tint-button {
    background: unset;
  }

  tint-button[disabled] {
    display: none !important;

    ~ div {
      display: none;
    }
  }
`;

export const selectColorButton = css`
  width: 158px;
  margin-bottom: var(--space-150);
`;

export const collectionNameContainer = css`
  display: flex;
  gap: var(--space-100);
  padding-top: var(--space-150);
`;
